<template>
  <div id="application">
    <div class="page">
      <Sidebar />
      <Header />
      <MobileHeader />
      <div class="main-content side-content pt-0">
        <div class="container-fluid">
          <div class="inner-body">
            <div class="page-header">
              <div>
                <h2 class="main-content-title tx-24 mg-b-5">{{ this.$store.state.pageTitle }}</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="modal effect-scale" id="national-religious" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content modal-content-demo">
                          <div class="modal-header">
                              <h6 class="modal-title">مناسبت های ملی / مذهبی</h6>
                              <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                          </div>
                          <div class="modal-body">
                              <ul class="mb-0">
                                <li v-for="(item,index) in $store.state.nationalReligious" :key="'nr-' + index">{{ item.title }} <span dir="ltr" style="float: left">{{ item.date }}</span></li>
                              </ul>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="modal effect-scale" id="organization" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content modal-content-demo">
                          <div class="modal-header">
                              <h6 class="modal-title">مناسبت های سازمانی</h6>
                              <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                          </div>
                          <div class="modal-body">
                              <ul class="mb-0">
                                <li v-for="(item,index) in $store.state.organization" :key="'or-' + index">{{ item.title }} <span dir="ltr" style="float: left">{{ item.date }}</span></li>
                              </ul>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="modal effect-scale" id="birthdates" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content modal-content-demo">
                          <div class="modal-header">
                              <h6 class="modal-title">مناسبت های پرسنلی</h6>
                              <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                          </div>
                          <div class="modal-body">
                              <ul class="mb-0">
                                <li v-for="(item,index) in $store.state.birthdates" :key="'bt-' + index">{{ item.title }} <span dir="ltr" style="float: left">{{ item.date }}</span></li>
                              </ul>
                          </div>
                      </div>
                  </div>
                </div>
                <router-view></router-view>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Sidebar from './Partials/Sidebar';
import Header from './Partials/Header';
import MobileHeader from './Partials/Header-Mobile';
import Footer from './Partials/Footer';
export default {
  name: 'App',
  components: {Sidebar,Header,MobileHeader,Footer}
}
</script>